import React, { useEffect, useState } from "react";
import "./Contract.css";
import HostContractDetails from "./HostContractDetails";
import VisitorContractDetails from "./VisitorContractDetails";
import { useLocation } from "react-router-dom";
import ContractPDF from "./ContractPDF";
import ShareContractDetail from "./ShareContractDetail";
import axios from "axios";
function Contract() {
  const location = useLocation();
  const [isHost, setIsHost] = useState(true);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [flowStep, setFlowStep] = useState("form");
  const [contractData, setContractData] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(false);
  const queryParams = new URLSearchParams(location.search);
  const Verification_token = queryParams.get("token");
  const [hasVerificationToken, setHasVerificationToken] = useState(
    !!Verification_token
  );
  const PUBLIC_API_URL = process.env.REACT_APP_API_BASE_URL;

  React.useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleFormSubmitSuccess = (data, token) => {
    setContractData(data);
    setToken(token);
    setFlowStep("shareContract");
  };

  const handleRoleChange = (role) => {
    setIsHost(role === "host");
  };

  useEffect(() => {
    let isMounted = true;
    const checkVerificationToken = async () => {
      if (hasVerificationToken) {
        setLoading(true);
        try {
          const response = await axios.get(
            `${PUBLIC_API_URL}contract/?token=${Verification_token}`
          );

          if (isMounted) {
            const role = response.data.data.host?.role;
            setIsHost(role !== "host");
          }
        } catch (error) {
          console.error("Error checking verification token:", error);
          if (isMounted) {
            setIsHost(true);
          }
        } finally {
          if (isMounted) {
            setLoading(false);
          }
        }
      }
    };

    if (hasVerificationToken && !contractData) {
      checkVerificationToken();
    }
    return () => {
      isMounted = false;
    };
  }, [hasVerificationToken, PUBLIC_API_URL]);

  const renderContent = () => {
    switch (flowStep) {
      case "form":
        return isHost ? (
          <HostContractDetails
            onSuccess={handleFormSubmitSuccess}
            setFlowStep={setFlowStep}
          />
        ) : (
          <VisitorContractDetails
            setFlowStep={setFlowStep}
            onSuccess={handleFormSubmitSuccess}
          />
        );
      case "shareContract":
        return (
          <ShareContractDetail contractData={contractData} token={token} />
        );
      case "pdf":
        return <ContractPDF token={Verification_token} />;
      default:
        return null;
    }
  };

  return (
    <div className="contract_main">
      <div className="bg_gradient_contract">
        <section className="generated_contract_hero">
          <div className="container-md generated_contract_hero_container">
            <div className="generated_contract_hero_content">
              <h1 className="generated_contract_title">Generated Contract</h1>
              <p className="generated_contract_description">
                This contract will provide a matching score to show the probability
                that you agree <br /> on the same terms for handling the swap.
              </p>
            </div>
            <img
              src="assets/img/faq-girl.png"
              id="contract_heroGirlImg_mobileView"
              alt="contract girl"
            />

            <div className="contract_heroImg">
              <img src="assets/img/faq-girl.png" alt="contract girl" />
            </div>
          </div>
        </section>
      </div>
      <div className="" style={{ width: "100%", backgroundColor: "#F7F6E9" }}>
        {flowStep === "form" && (
          <div className="contract_form_container">
            <div className="contract_form">
              <div className="contract_checkbox_mode">
                <label
                  htmlFor="contract_checkbox_title"
                  className="contract_field_title"
                >
                  1. Are you visitor or Host?
                </label>

                <div className="contract_checkbox">
                  <span>
                    <input
                      type="checkbox"
                      name="role"
                      value={"guest"}
                      checked={!isHost}
                      onChange={() =>
                        !hasVerificationToken && handleRoleChange("visitor")
                      }
                      disabled={hasVerificationToken}
                    />
                    <label className="contract_mode_checkbox_label">
                      I’m guest{" "}
                    </label>
                  </span>
                  <span>
                    <input
                      type="checkbox"
                      name="role"
                      value={"host"}
                      id="host-role"
                      checked={isHost}
                      onChange={() =>
                        !hasVerificationToken && handleRoleChange("host")
                      }
                      disabled={hasVerificationToken}
                    />
                    <label className="contract_mode_checkbox_label">
                      I’m host{" "}
                    </label>
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}
        <div>{renderContent()}</div>
      </div>
    </div>
  );
}

export default Contract;
